import React from 'react';
import { MessageCircle } from 'lucide-react';

const FloatingWhatsApp = () => {
  const whatsappNumber = "+9660590317360";
  const message = "مرحباً، أرغب في الاستفسار عن خدماتكم التعليمية";
  
  const handleClick = () => {
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="fixed bottom-6 left-6 z-50">
      <button
        onClick={handleClick}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-110 animate-pulse hover:animate-none group"
        aria-label="تواصل عبر واتساب"
      >
        <MessageCircle className="h-8 w-8" />
        
        {/* النص الذي يظهر عند التمرير */}
        <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          تواصل معنا عبر واتساب
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2 translate-x-full">
            <div className="w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-gray-800"></div>
          </div>
        </div>
      </button>
    </div>
  );
};

export default FloatingWhatsApp;